/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useEffect, useCallback, useRef, useImperativeHandle } from "react";
import axios from 'util/axios';

import { table_render, html_render } from "../Functions";

import ReviewStartBtn from "./ReviewStartBtn";
import RefreshBtn from "./RefreshBtn";
import { useDispatch, useSelector } from "react-redux";
import ReviewComponent from "util/component/Review";
import UnconfirmedListV2 from "./UnconfirmedListV2";

const ReviewContent = (props) => {
    const { ownerId } = props;
    const [Data, SetData] = useState();
    const [List, SetList] = useState({ content: [], table: [], image: [] });

    const [Reviewing, SetReviewing] = useState(false);
    const dispatch = useDispatch();
    const userSelector = useSelector((store) => store.user);
    const [Selected, SetSelected] = useState(null);

    const postData = useRef(null);

    const containerRef = useRef(null);

    const getDocData = async () => {
        dispatch({ type: "LOADING_ON" });
        try {
            postData.current = { ...props, userId: userSelector.userId };
            const revInfo = await axios
                .post(process.env.REACT_APP_API + "/pcsReview/retrieveCheckEndReview", postData.current)
                .then((Response) => Response?.data?.data?.result);
            if (revInfo) {
                const docData = await axios
                    .post(process.env.REACT_APP_API + "/pcsGenerate/retrieveGenerateTemplateForSave", postData.current)
                    .then((Response) => Response.data.data);
                const revData = await axios
                    .post(process.env.REACT_APP_API + "/pcsReview/retrieveReviewGenerateList", postData.current)
                    .then((Response) => Response?.data?.data);
                const revAllData = await axios
                    .post(process.env.REACT_APP_API + "/pcsReview/retrieveCommentFilterList", postData.current)
                    .then((Response) => Response?.data?.data?.result);
                SetData({ doc: docData, rev: revData.result, revInfo: revInfo, revAllData: revAllData, Owners : revData.templateOwners });
            }
        } catch (e) {
            console.error(e);
        } finally {
            dispatch({ type: "LOADING_OFF" });
        }
    };

    const HandleReviewClick = (e) => {
        const { target } = e;
        
        SetSelected(null);
        if (target?.dataset?.cellnm && target?.closest(".reviewable")) {
            e.preventDefault();
            e.stopPropagation();
            const sheetinfo = target.closest("[data-sheetinfo]")?.dataset.sheetinfo?.split("|");
            const sheetcd = sheetinfo[0];
            const revision = sheetinfo[1];
            const tempYn = sheetinfo[2];
            const uniqueCode = target.closest("[data-uniquecode]")?.dataset.uniquecode;
            const cellnm = target.dataset?.cellnm;

            containerRef.current.querySelectorAll(".selected").forEach((e) => {
                e.classList.remove("selected");
            });
            target.classList.add("selected");

            const elementPosition = target.getBoundingClientRect();
            const offsetPosition = elementPosition.top + window.pageYOffset - 200;

            // eslint-disable-next-line no-restricted-globals
            const windowX = self.innerWidth;

            let positionX = windowX - elementPosition.right;
            if (windowX - 450 < elementPosition.right) {
                positionX = windowX - elementPosition.left + 450;
                if (elementPosition.left < 450) {
                    positionX = elementPosition.right - 450;
                }
            }
            SetSelected({
                master: { ...props, userId: userSelector.userId },
                sheetcd,
                revision,
                tempYn,
                uniqueCode,
                cellnm,
                revtype: null,
                positionX: positionX - 450,
                positionY: offsetPosition,
            });
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        } else if (target?.closest("[data-revtype]") && target?.closest("[data-uniquecode]")) {
            e.preventDefault();
            e.stopPropagation();
            const sheetinfo = target.closest("[data-sheetinfo]")?.dataset.sheetinfo?.split("|");
            const sheetcd = sheetinfo[0];
            const revision = sheetinfo[1];
            const tempYn = sheetinfo[2];
            const uniqueCode = target.closest("[data-uniquecode]")?.dataset.uniquecode;
            const revtype = target.closest("[data-revtype]")?.dataset.revtype;
            const cellnm = "Description Review Data";

            containerRef.current.querySelectorAll(".selected").forEach((e) => {
                e.classList.remove("selected");
            });
            target.closest("[data-uniquecode]").classList.add("selected");

            const elementPosition = target.getBoundingClientRect();
            const offsetPosition = elementPosition.top + window.pageYOffset - 200;

            // eslint-disable-next-line no-restricted-globals
            const windowX = self.innerWidth;

            let positionX = windowX - elementPosition.right;
            if (windowX - 450 < elementPosition.right) {
                positionX = windowX - elementPosition.left + 450;
                if (elementPosition.left < 450) {
                    positionX = elementPosition.right - 450;
                }
            }

            SetSelected({
                master: { ...props, userId: userSelector.userId },
                sheetcd,
                revision,
                tempYn,
                uniqueCode,
                cellnm,
                revtype,
                positionX: positionX,
                positionY: offsetPosition,
            });
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        } else {
            if (!target?.closest(".review-content-popup")) {
                containerRef.current.querySelectorAll(".selected").forEach((e) => {
                    e.classList.remove("selected");
                });
            }
        }
    };

    useEffect(() => {
        if (!Selected) {
            containerRef.current.querySelectorAll(".selected").forEach((e) => {
                e.classList.remove("selected");
            });
        }
    }, [Selected]);

    useEffect(() => {
        if (props?.geneCode) {
            getDocData();
        }

        // document.addEventListener("click", HandleReviewClick)

        return () => {
            containerRef.current?.removeEventListener("click", HandleReviewClick);
        };
    }, [props]);

    const HandleReviewing = (bool) => {
        const postData = {
            ...props,
            assignUser: userSelector.userId,
            connectType: bool ? "S" : "E",
        };
        axios
            .post(process.env.REACT_APP_API + "/pcsReview/createRevWorkflowTime", postData)
            .then((Response) => Response.data.data.result)
            .then((result) => {
                if (result === "1") {
                    getDocData();
                }
            })
            .catch((e) => console.error(e));
    };

    const RevInfoRender = useMemo(() => {
        const dataMap = Data?.doc?.sheetList?.map((tbl) => {
            const { master, tempYn } = tbl;
            return { ...master, tempYn };
        });
        return dataMap?.map((tblData, index) => {
            const { projectNm, mbrNo, processCd, unitNm, revision, tempYn } = tblData;
            return (
                <tr key={`revisinoInfo${index}`} className={`text-center`}>
                    <td>{projectNm}</td>
                    <td>{mbrNo}</td>
                    <td>{processCd}</td>
                    {/* <td>{unitNm}</td> */}
                    <td>
                        <span className={`bpl-temp-v2-${tempYn}`}>{revision}</span>
                    </td>
                </tr>
            );
        });
    }, [Data]);

    const MainRender = useMemo(() => {
        
        if (!Data?.doc) {
            return <h1>No Data</h1>;
        }

        const { doc, rev } = Data;

        let descRev = [];
        Object.keys(rev)?.forEach((f) => {
            if (f.toString().toUpperCase().match(/^DS/)) descRev = rev[f];
        });

        const descInfo = doc?.desc[0];

        const Header = html_render(
            descInfo?.descHeader,
            descRev.filter((f) => f.revType.toString().match(/H/))
        );
        const Common = html_render(
            descInfo?.descCommon,
            descRev.filter((f) => f.revType.toString().match(/C/))
        );
        const Footer = html_render(
            descInfo?.descFooter,
            descRev.filter((f) => f.revType.toString().match(/F/))
        );
        const descInfoStr = `${descInfo?.descCode}|${descInfo?.revision}|${descInfo?.tempYn}`;

        let shinfo = "";

        const Tables = doc?.sheetList?.map((tbl) => {
            const sheetInfo = `${tbl.master?.sheetCode}|${tbl.master?.revision}|${tbl?.["tempYn"]}`;
            if (!shinfo) shinfo = sheetInfo;

            const sheetCode = tbl.master?.sheetCode?.toString().toUpperCase();
            let reviewData = [];
            Object.keys(rev)?.forEach((f) => {
                if (f.toString().toUpperCase() === sheetCode) reviewData = rev[f];
            });

            let desc;

            desc = html_render(tbl.master?.webContent, reviewData);

            let htmlStr = [];

            const isExternal = userSelector.isExternal;

            if (tbl["composition"] && tbl["composition"].length > 0) {
                htmlStr.push(table_render("composition", tbl, reviewData, isExternal));
            }
            htmlStr.push(table_render("in", tbl, reviewData, isExternal));
            htmlStr.push(table_render("out", tbl, reviewData, isExternal));
            htmlStr.push(table_render("qc", tbl, reviewData, isExternal));

            return {
                tables: htmlStr,
                desc: desc,
                sheetInfo: sheetInfo,
                tempYn: tbl?.["tempYn"],
            };
        });
        return (
            <>
                <div
                    className={`pdf-page ck-content temp${descInfo?.tempYn}`}
                    data-sheetinfo={`${descInfoStr}`}
                    data-revtype={`H`}
                    dangerouslySetInnerHTML={{ __html: Header }}
                ></div>
                <div
                    className={`pdf-page ck-content temp${descInfo?.tempYn}`}
                    data-sheetinfo={`${descInfoStr}`}
                    data-revtype={`C`}
                    dangerouslySetInnerHTML={{ __html: Common }}
                ></div>
                {Tables?.map((tbl, i) => {
                    return (
                        <React.Fragment key={"pdfpreview" + i}>
                            {tbl.desc && (
                                <div
                                    className={`pdf-page ck-content temp${tbl.tempYn}`}
                                    data-sheetinfo={`${tbl.sheetInfo}`}
                                    data-revtype={`D`}
                                    dangerouslySetInnerHTML={{ __html: tbl.desc }}
                                ></div>
                            )}
                            {tbl.tables?.map((tblInner, i2) => {
                                if (tblInner) {
                                    return (
                                        <div
                                            key={"pdfpreview" + i + "_" + i2}
                                            className={`pdf-page ck-content data-tables temp${tbl.tempYn}`}
                                            data-sheetinfo={`${tbl.sheetInfo}`}
                                            dangerouslySetInnerHTML={{ __html: tblInner }}
                                        ></div>
                                    );
                                } else return null;
                            })}
                        </React.Fragment>
                    );
                })}
                <div
                    className={`pdf-page ck-content temp${descInfo?.tempYn}`}
                    data-revtype={`F`}
                    data-sheetinfo={`${descInfoStr}`}
                    suppressHydrationWarning
                    dangerouslySetInnerHTML={{ __html: Footer }}
                ></div>
            </>
        );
    }, [Data]);

    useEffect(() => {
        if (Data?.doc) {
            const { revInfo } = Data;
            SetReviewing(revInfo?.reviewing === "I");

            document.querySelectorAll("span")?.forEach((e) => {
                const color = e.style.backgroundColor;
                if (color) {
                    e.style.backgroundColor = "transparent";
                    e.style.textShadow = "0px 0px 10px " + color;
                }
            });

            let cnt = 0;  
            let cnt2 = 0;
            let cnt3 = 0;
            let cnt4 = 0;

            let tCnt = 0;
            let tImg = 0;
            const contentList = { content: [], table: [], image: [] };

            
            
            containerRef.current?.querySelectorAll("h1, h2, h3, h4, figcaption")?.forEach((e) => {
                if (e.tagName.toUpperCase() === "FIGCAPTION") {
                    const figure = e.closest("figure");
                    const isTable = figure.classList.contains("table");
                    const isImage = figure.classList.contains("image");
                    if (isTable) {
                        tCnt++;
                        e.innerHTML = `Table ${tCnt}. ` + e.innerHTML.toString().replaceAll(/^Table [\d.]+\. /g, "");
                        contentList.table.push({ innerHTML: e, id: `tbl${tCnt}`, tbltp: e.dataset.tblnm && e.dataset.tblnm+e.dataset.tbltp });
                        e.id = `tbl${tCnt}`;
                    } else if (isImage) {
                        tImg++;
                        e.innerHTML = `Figure ${tImg}. ` + e.innerHTML.toString().replaceAll(/^Figure [\d.]+\. /g, "");
                        contentList.image.push({ innerHTML: e, id: `img${tImg}` });
                        e.id = `img${tImg}`;
                    }
                } else {
                    let isDataTable = e.classList.contains("exclude_heading");
                    // let visible = true;
                    switch (e.tagName.toUpperCase()) {
                        case "H1":
                            cnt++;
                            e.innerHTML = `${cnt}. ` + e.innerHTML.toString().replaceAll(/^[\d. ]+\./g, "");
                            cnt2 = 0;
                            cnt3 = 0;
                            cnt4 = 0;
                            break;
                        case "H2":
                            cnt2++;
                            e.innerHTML = `${cnt}.${cnt2}. ` + e.innerHTML.toString().replaceAll(/^[\d. ]+\./g, "");

                            cnt3 = 0;
                            cnt4 = 0;
                            break;
                        case "H3":
                            cnt3++;
                            e.innerHTML = `${cnt}.${cnt2}.${cnt3}. ` + e.innerHTML.toString().replaceAll(/^[\d. ]+\./g, "");

                            cnt4 = 0;
                            isDataTable = true;
                            break;
                        case "H4":
                            cnt4++;
                            e.innerHTML =
                                `${cnt}.${cnt2}.${cnt3}.${cnt4}. ` + e.innerHTML.toString().replaceAll(/^[\d. ]+\./g, "");
                            isDataTable = true;
                            break;
                        default:
                            break;
                    }
                    e.id = `${cnt}_${cnt2}_${cnt3}_${cnt4}`;
                    contentList.content.push({
                        innerHTML: e,
                        isDataTable: isDataTable,
                        id: `${cnt}_${cnt2}_${cnt3}_${cnt4}`,
                    });
                }
            });
            
            const ref_list = [...contentList.table, ...contentList.image];
            document.querySelectorAll("a.tblref").forEach((e) => {
                try {
                    const tr = e.dataset.tblref?.toLowerCase().replace(/^\[:(.*):\]$/,"$1").split("::");
                    let ref;
                    if(tr.length > 2) {
                        const qs = (tr[0]+tr[1]).toUpperCase();
                        const tbl = tr[2].toUpperCase();
                        ref = ref_list.filter(ft => ft.tbltp).find(fi => fi.tbltp === qs+tbl);
                    } else {
                        const tbl_name = tr[tr.length-1];
                        ref = ref_list.find(f => {
                            let ele = f.innerHTML?.innerText;
                            ele = ele.replace(/^(table|figure) [0-9]+\. /i,'').trim().toLowerCase();
                            return ele.startsWith(tbl_name.toLowerCase());
                        });
                    }
                    
                    try {
                        if(ref) {
                            e.innerHTML = "["+ref.innerHTML.innerText+"]";
                            e.href = "#"+ref.id;
                            
                            e.classList.remove("tblref");
                        } else {
                            e.innerHTML = "[#REFERROR!]"
                        }
                    } catch(e) {
                        
                    } finally {
                        // e.classList.remove("tblref");
                    }
                } catch(e) { console.error(e)}
            })
            

            // Table 깨짐 수정
            document.querySelectorAll("*:not(.fixfigure) > figure").forEach((e) => {
                try {
                    if (e.style?.width.includes("%")) {
                        const widthPercent = parseFloat(e.style.width.replaceAll(/%$/g, ""));
                        if (widthPercent > 100) {
                            e.style.width = "100%";
                        }
                    }
                    if (e.style?.height) {
                        e.style.height = null;
                    }
                    e.outerHTML = `<div class='fixfigure' style="width: 100%; display: block">${e.outerHTML}</div>`;
                } catch (e) {
                    console.error(e);
                }
            });

            
            SetList(contentList);
            containerRef.current?.addEventListener("click", HandleReviewClick);
        }
       
        return () => {
            containerRef.current?.removeEventListener("click", HandleReviewClick);
        };
    }, [Data]);

    const ListRender = useMemo(() => {
        const { content, table, image } = List;
        if (Data?.doc) {
            return (
                <>
                    <div className="pdf-page ck-content contentlist">
                        <p
                            style={{
                                fontSize: "1.15rem",
                                // textAlign: "center",
                                fontWeight: "bold",
                                margin: "7pt 0",
                            }}
                        >
                            List of Contents
                        </p>
                        {content?.map((e, i) => {
                            const { innerHTML, id, isDataTable } = e;
                            if (!isDataTable) {
                                const margin = (innerHTML.innerHTML?.match(/^(\d+.)+ /)?.[0]?.split(".")?.length ?? 2) - 2;

                                return (
                                    <a
                                        key={"docPreviewList" + i}
                                        style={{
                                            marginLeft: (margin < 1 ? 0 : margin * 0.5) + "rem",
                                        }}
                                        href={"#" + id}
                                        dangerouslySetInnerHTML={{ __html: innerHTML.innerHTML }}
                                    ></a>
                                );
                            } else return null;
                        })}
                    </div>
                    {table.length > 0 && (
                        <div className="pdf-page ck-content contentlist">
                            <p
                                style={{
                                    fontSize: "1.15rem",
                                    // textAlign: "center",
                                    fontWeight: "bold",
                                    margin: "7pt 0",
                                }}
                            >
                                List of Tables
                            </p>
                            {table?.map((e, i) => {
                                const { innerHTML, id, isDataTable } = e;
                                if (!isDataTable) {
                                    return (
                                        <a
                                            key={"docPreviewListTbl" + i}
                                            href={"#" + id}
                                            dangerouslySetInnerHTML={{ __html: innerHTML.innerHTML }}
                                        ></a>
                                    );
                                } else return null;
                            })}
                        </div>
                    )}
                    {image.length > 0 && (
                        <div className="pdf-page ck-content contentlist">
                            <p
                                style={{
                                    fontSize: "1.15rem",
                                    // textAlign: "center",
                                    fontWeight: "bold",
                                    margin: "7pt 0",
                                }}
                            >
                                List of Figures
                            </p>
                            {image?.map((e, i) => {
                                const { innerHTML, id, isDataTable } = e;
                                if (!isDataTable) {
                                    return (
                                        <a
                                            key={"docPreviewListImg" + i}
                                            href={"#" + id}
                                            dangerouslySetInnerHTML={{ __html: innerHTML.innerHTML }}
                                        ></a>
                                    );
                                } else return null;
                            })}
                        </div>
                    )}
                </>
            );
        } else return null;
    }, [Data, List]);

    return (
        <>
            <div style={{ width: "100%", paddingTop: "100px" }}>
                <div id="review-container" ref={containerRef}>
                    {ListRender}

                    {MainRender}
                    {Data && (
                        <div
                            className="pdf-page ck-content"
                            style={{
                                width: "60%",
                                marginLeft: "auto",
                                marginRight: "auto",
                            }}
                        >
                            <table className="bpl-table-default gray-tone small fixed" style={{ width: "100%" }}>
                                <colgroup>
                                    <col width="50" />
                                    <col width="50" />
                                    <col width="50" />
                                    <col width="50" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>Project</th>
                                        <th>MBR No.</th>
                                        <th>Process</th>
                                        {/* <th>Unit Op.</th> */}
                                        <th>Version</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">{RevInfoRender}</tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>

            {Selected && <ReviewComponent {...Selected} close={SetSelected} refresh={getDocData} templateOwners={Data} pcsOwnerId={ownerId} />}
            {Data && <UnconfirmedListV2 comment ={Selected} doc={Data} refresh={getDocData} reviewing={Reviewing} setReviewing={HandleReviewing} close={SetSelected} templateOwners={Data} pcsOwnerId={ownerId}/>}
            {/*{Data && <RefreshBtn getData={getDocData} />}*/}
            {Data?.revInfo && Data?.revInfo?.reviewEnd !== "Y" && (
                <ReviewStartBtn reviewing={Reviewing} setReviewing={HandleReviewing} />
            )}
        </>
    );
};

const areEquals = (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next);
};

export default React.memo(ReviewContent, areEquals);
